// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html,body{margin:0}body{background-color:#bd2534;color:rgba(255,255,255,.7019607843)}.layout-main-container{display:flex;height:calc(100vh - 60px);width:100%}.main-scene{padding-bottom:8em}", ""]);
// Exports
module.exports = exports;
